import {Image, ImageProps} from 'platform/foundation';

import {AdServer} from '../../types/AdServer';

interface AdServerLogoProps {
  logo: AdServer;
  maxHeight: ImageProps['maxHeight'];
}

export function AdServerLogo(props: AdServerLogoProps) {
  return (
    <Image
      src={`/assets/images/ad-server-logo/${props.logo}.svg`}
      maxHeight={props.maxHeight}
      fit="contain"
      position="left"
    />
  );
}
